import axios from 'axios'

const port = 'https://ouss-portfolio.herokuapp.com/'

const instance = axios.create({
    baseURL : port
})

export default instance;